export const SIDEBAR_TRANSITION_DURATION = 175;
export const SIDEBAR_LS_KEY = "webiny_sidebar_state";
